import { render } from "./ApprovedWOTable.vue?vue&type=template&id=13af0178"
import script from "./ApprovedWOTable.vue?vue&type=script&lang=js"
export * from "./ApprovedWOTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__